<template>
  <div>
    <br />
    <AlertLinkEntity :payload="payload.resources.applicant" :additional_data="{ resource_type: 'Applicant', endpoint: '/users/', headers: 'admin_headers' }" />
    <br />
    <br />
    <LinkEntity :payload="payload.resources.company" :additional_data="{ resource_type: 'Company' }" />
    <br />
    <br />
    <AlertLinkEntity :payload="payload.resources.position" :additional_data="{ resource_type: 'Position', endpoint: '/positions/', headers: 'admin_headers' }" />
  </div>
</template>

<script>
import LinkEntity from '@/components/LinkEntity'
import AlertLinkEntity from '@/components/AlertLinkEntity'

export default {
  name: 'AlertResourceCell',
  components: {
    LinkEntity,
    AlertLinkEntity
  },
  props: {
    payload: {
      type: Object,
      required: true
    }
  }
}
</script>
